import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function useCustomers() {
  const [customers, setCustomers] = useState([]);

  const load = useCallback(() => api.get("/admin/customers").then((r) => setCustomers(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const createCustomer = async (body) => {
    await api.post("/admin/customers", body);
    toast.success("Customer created");
    await load();
  };

  const updateCustomer = async (id, body) => {
    await api.put(`/admin/customers/${id}`, body);
    toast.success("Customer updated");
    await load();
  };

  const removeCustomer = async (id) => {
    await api.post(`/admin/users/${id}/soft-delete`);
    toast.success("Moved to trash");
    await load();
  };

  const toggleBlock = async (c) => {
    const action = c.status === "blocked" ? "unblock" : "block";
    const { data } = await api.post(`/admin/customers/${c.id}/${action}`);
    toast.success(data.message);
    await load();
  };

  const approveCustomer = async (id, body) => {
    await api.post(`/admin/customers/${id}/approve`, body);
    await load();
  };

  const setPassword = async (id, newPassword) => {
    await api.post(`/admin/customers/${id}/set-password`, { new_password: newPassword });
  };

  return { customers, createCustomer, updateCustomer, removeCustomer, toggleBlock, approveCustomer, setPassword };
}
